import riverIMG from './river.mp4';
import text from './text';

export const story = {
    slug: 'river',
    title: 'River',
    interactive: 'river',
    img: riverIMG,
    year: 'Wave after endless wave',
    tags: ['sci-fi'],
    md: text,
}